import PropTypes from 'prop-types';
import { useContext } from 'react';

import { dateFormatForMobileUI } from 'utils/date';
import { SearchContext } from '../../state/search';
import NestedFilterDropdown from '../nestedFilterDropdown';
import DatepickerField from '../fields/datepickerField';
import Switch from '../switch';

const MobileSpaceFilters = ({
  currentViewType,
  updateCurrentPage,
  changeViewType,
  aggregates,
}) => {
  const { filters, actions } = useContext(SearchContext);

  return (
    <div className="mobile-space-filters">
      <div className="mobile-space-filters__container">
        <DatepickerField
          value={filters.date}
          onChange={date => {
            updateCurrentPage(1);
            actions.updateDate(date);
          }}
          dateFormat={dateFormatForMobileUI}
        />
        <NestedFilterDropdown
          aggregates={aggregates}
          filters={filters}
          actions={actions}
          updateCurrentPage={updateCurrentPage}
        />
        <div className="mobile-space-filters__switch">
          <Switch
            offLabel="Map"
            onLabel="List"
            toggled={currentViewType === 'map'}
            onSwitchChange={changeViewType}
          />
        </div>
      </div>
    </div>
  );
};

MobileSpaceFilters.propTypes = {
  changeViewType: PropTypes.func.isRequired,
  currentViewType: PropTypes.string,
  aggregates: PropTypes.object,
};

MobileSpaceFilters.defaultProps = {
  currentViewType: 'list',
  aggregates: { property: [], distance: [] },
};

export default MobileSpaceFilters;
